import React, { useEffect } from 'react'
import { Formik } from 'formik'
import { Button, Grid } from '@mui/material'
import { useAppDispatch } from '../../../../app/hooks'

import ErrorComponent from '../../../components/ui-widgets/ErrorComponent'
import {
  type PortfolioSettlementProjectDto
} from '../../../../api-schema-types/asset-holdings/AdminPortfolioSettlementDomainDtos'
import ViewSettlementProjectDetail from './ViewSettlementProjectDetail'
import { setNotification } from '../../../components/ui-widgets/uiWidgetsSlice'
import {
  useUpdateSettlementPortfolioProjectMutation
} from '../../../../api-services/asset-holdings/portfolioSettlementsApi'
import { RtkQueryHelper } from '../../../../api-services/shared/RtkQueryHelper'

export interface EditSettlementProjectFormProps {
  settlementProject: PortfolioSettlementProjectDto
  triggerRefetch: () => void
}

const EditSettlementForm: React.FC<EditSettlementProjectFormProps> = ({ settlementProject, triggerRefetch }: EditSettlementProjectFormProps) => {
  const dispatch = useAppDispatch()

  // ================================================================================================================
  //  FORM SETUP
  // ================================================================================================================

  const updateSettlementProjectOnSubmit = async (values: PortfolioSettlementProjectDto): Promise<void> => {
    const updateSettlementProject = { ...values }
    // updateSettlementProject.portfolioSettlementProjectId
    await apiUpdateSettlementProjectTrigger({ ...updateSettlementProject })
    // dispatch(setOverrideLockedFields(false))
  }

  // ================================================================================================================
  //  FORM MUTATION + RESULT
  // ================================================================================================================

  // const [apiUpdateProjectTrigger, updateResult] = useUpdateProjectMutation()
  const [apiUpdateSettlementProjectTrigger, updateResult] = useUpdateSettlementPortfolioProjectMutation()

  useEffect(() => {
    if (updateResult.isSuccess) {
      dispatch(setNotification({ open: true, severity: 'success', message: 'Portfolio Settlement Project updated successfully' }))
    }

    if (updateResult.isError) {
      dispatch(setNotification({
        open: true,
        severity: 'error',
        message: RtkQueryHelper.mapResponseError(updateResult.error)
      }))
    }
  }, [updateResult.isSuccess, updateResult.isError])

  const handleCancel = async (): Promise<void> => {
    dispatch(setNotification({
      open: true,
      severity: 'warning',
      message: 'Edit action cancelled. Portfolio Settlement Project has been reloaded.'
    }))
    triggerRefetch()
  }

  return (
    <>

      <Formik
        initialValues={settlementProject}
        // validationSchema={validateAssetProjectUpdateDto}
        onSubmit={async (values, actions) => {
          await updateSettlementProjectOnSubmit(values)
        }}
      >
        {formikProps => (

          <form
            autoComplete={'off'}
            autoCorrect={'off'}
            onSubmit={formikProps.handleSubmit}
          >

            {!formikProps.isValid && (
              <Grid item md={12} sx={{ mt: 2 }}>
                <ErrorComponent title={'Form validation error'} message={JSON.stringify(formikProps.errors)}/>
              </Grid>
            )}
            <Grid item md={12} sx={{ mt: 2 }}>
                <ViewSettlementProjectDetail settlementProject={settlementProject} triggerRefetch={triggerRefetch}/>
            </Grid>

              <Grid container spacing={4}>
                  <Grid item lg={12} >
                      <Button variant={'contained'} disabled={!formikProps.isValid} type={'submit'} sx={{ mr: 3 }} >
                          Update Details
                      </Button>
                      <Button type={'button'} variant={'text'} onClick={handleCancel}>
                          Cancel
                      </Button>
                  </Grid>
              </Grid>
          </form>

        )}
      </Formik>

    </>
  )
}

export default EditSettlementForm
